import module from 'nominas/finiquito/module.js'

const schema = {
  aplicado: 'boolean',
  id_finiquito: 'number',
  id_escenario: 'number',
  id_tipo_comision: 'number',
  id_metodo_calculo_comision: 'number',
  comision_importe: 'number',
  comision_porcentaje: 'number',
  configuracion: {
    cobrar_impuesto_estatal: 'boolean',
    complemento_aguinaldo: 'number',
    complemento_vacaciones: 'number',
    factor_dias_mes: 'number',
    factor_prima_vacacional: 'number',
    fecha_inicial: 'date',
    fecha_final: 'date',
    id_regimen_fiscal: 'number',
    id_tipo_nomina: 'number',
    id_metodo_calculo_suministro: 'number',
    id_metodo_calculo_comision: 'number',
    importe_finiquito: 'number',
    impuesto_estatal: 'number',
    fondo_ahorro_porcentaje: 'number',
    piramidar: 'boolean',
    proratear_subsidio: 'boolean',
    salario_minimo: 'number',
    subsidio_mensual: 'number',
    tarifa: 'number',
    uma_importe: 'number',
    tipo_calculo_id: 'number',
  },
  calculado: 'boolean',
  colaborador: {
    comision_importe: 'number',
    comision_porcentaje: 'number',
    acumulado: {
      anual: {
        percepciones: {
          id_concepto: 'number',
          importe: 'number',
          gravado: 'number',
        },
        deducciones: {
          id_concepto: 'number',
          importe: 'number',
          gravado: 'number',
        },
      },
      mensual: {
        subsidioDeterminado: 'number',
        impuestoDeterminado: 'number',
        subsidioCausado: 'number',
        impuestoCausado: 'number',
        percepciones: {
          id_concepto: 'number',
          importe: 'number',
          gravado: 'number',
        },
        deducciones: {
          id_concepto: 'number',
          importe: 'number',
          gravado: 'number',
        },
      },
    },
    config: {
      absorber_cuota_obrera: 'number',
      absorber_cuota_patronal: 'number',
      absorber_impuesto_estatal: 'number',
      absorber_isr: 'number',
      calculo_mensual_acumulado: 'boolean',
      aguinaldo_exento: 'number',
      asimilados_acumulado: 'number',
      carga_social_pendiente: 'number',
      cobro_carga_social: 'boolean',
      dias_carga_social: 'number',
      dias_trabajados: 'number',
      dias_trabajados_aguinaldo: 'number',
      dias_trabajados_vacaciones: 'number',
      estrategiaId: 'number',
      fecha_ingreso: 'date',
      fecha_baja: 'date',
      fecha_imss_alta: 'date',
      fecha_imss_baja: 'date',
      fecha_suspension: 'date',
      fonacot_pendiente: 'number',
      fonacot_pendiente_saldo: 'number',
      id_regimen_fiscal: 'number',
      id_tipo_nomina: 'number',
      infonavit_deduccion_valor: 'number',
      infonavit_pendiente: 'number',
      infonavit_pendiente_saldo: 'number',
      isr_acumulado: 'number',
      prima_riesgo: 'number',
      prima_vacacional_exento: 'number',
      reparto_utilidades_exento: 'number',
      salario_diario: 'number',
      salario_diario_integrado: 'number',
      salario_diario_ordinario: 'number',
      salario_mensual: 'number',
      porcentajeTarifa: 'number',
      diasMensual: 'number',
      topeSueldo: 'number',
      salario_mensual_ordinario: 'number',
      subsidio_acumulado: 'number',
      subsidio_acumulado_pagado: 'number',
      tarifa: 'number',
      subsidioDeterminado: 'number',
      impuestoDeterminado: 'number',
      nominaOrdinaria: 'boolean',
    },
    prestamos: {
      abono: 'number',
      creditoId: 'number',
      importe: 'number',
      tipoDescuentoId: 'number',
      tipoDeduccion: '',
      totalAbonos: 'number',
      valorDeduccion: 'number',
    },
    deducciones: {
      id_concepto: 'number',
      importe: 'number',
      exento: 'number',
      gravado: 'number',
      dias: 'number',
      horas: 'number',
      complemento: 'number',
      impuesto_estatal: 'number',
      calculable: 'boolean',
    },
    id_tipo_comision: 'number',
    importe: 'number',
    importe_divisa: 'number',
    neto: 'number',
    neto_a_pagar: 'number',
    percepciones: {
      id_concepto: 'number',
      importe: 'number',
      exento: 'number',
      gravado: 'number',
      dias: 'number',
      horas: 'number',
      complemento: 'number',
      impuesto_estatal: 'number',
      calculable: 'boolean',
    },
    prevision_social: 'number',
    status_calculado: 'boolean',
    total_deducciones: 'number',
    total_percepciones: 'number',
    total_prestamos: 'number',
    total_servicios: 'number',
    ultima_nomina: {
      fecha: 'date',
      fecha_inicial: 'date',
      fecha_final: 'date',
    },
  },
}

export class NominasFiniquitoEscenario {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, idColaborador, idFiniquito, idEscenario) {
    return this.$http.get('/api/nominas/finiquitos/finiquito/escenarios/escenario', {
      params: {
        id_proyecto: idProyecto,
        id_colaborador: idColaborador,
        id_finiquito: idFiniquito,
        id_escenario: idEscenario,
      },
      schema,
    })
  }

  delete (idProyecto, idColaborador, idFiniquito, idEscenario) {
    return this.$http.delete('/api/nominas/finiquitos/finiquito/escenarios/escenario', {
      params: {
        id_proyecto: idProyecto,
        id_colaborador: idColaborador,
        id_finiquito: idFiniquito,
        id_escenario: idEscenario,
      },
      schema,
    })
  }

  put (idProyecto, idColaborador, idFiniquito, idEscenario, data) {
    return this.$http.put('/api/nominas/finiquitos/finiquito/escenarios/escenario', data, {
      params: {
        id_proyecto: idProyecto,
        id_colaborador: idColaborador,
        id_finiquito: idFiniquito,
        id_escenario: idEscenario,
      },
      schema,
    })
  }
}

module.service('NominasFiniquitoEscenario', NominasFiniquitoEscenario)



// WEBPACK FOOTER //
// ./src/nominas/finiquito/services/Finiquito/Escenario.js